<template>
  <div class="modal-cover" data-grm-comp="Chat" @click="onClose" v-if="!isLeaved">
    <div class="chat-container" @click.stop>
      <div class="chat-header-container">
        <button class="close-modal" @click="onClose"></button>
        <div>{{ $t('camstudy.chat.title') }}</div>
        <div class="chat-icon"></div>
      </div>
      <div class="chat-body-container overflow-auto" ref="scroll">
        <div class="warning-info">
          <div class="warning-title">{{ $t('camstudy.chat.reportTitle') }}</div>
          <div class="warning-message">{{ $t('camstudy.chat.reportMessage') }}</div>
        </div>
        <div class="chat-list">
          <div class="chat-scroll" ref="chatScroll"></div>
          <MyChat/>
        </div>
      </div>
      <div class="chat-input-container">
        <div class="w-20 flex-shrink-0 chat-input-select-container">
          <GrmCamstudySelect
              :title="$t('camstudy.chat.target')"
              name="whisper-target"
              :list="displayChatTargetList"
              :value="selectedWhisperTarget"
              @onChange="onChangeWhisperTarget"
          />
        </div>
        <div class="chat-input">
          <input type="text" ref="input-real" v-model="inputValue" maxlength="1000" :placeholder="$t('camstudy.chat.inputPlaceholder')" @keyup.enter="sendChat">
          <input type="text" ref="input-fake" class="fake-input" />
          <button class="send-chat" :class="{possible: inputLengthCheck}" @click="sendChat"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {i18n} from '@/locales/i18n'
import store from '@/store'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import MyChat from '@/components/Room/Camstudy/control/MyChat.vue'
import ChatForm from '@/components/Room/Camstudy/control/ChatForm.vue'
import dayjs from 'dayjs'
import GrmCamstudySelect from '@/components/Common/camstudySelect/GrmCamstudySelect.vue'

export default {
  name: 'CamstudyChatModal',
  components: {
    GrmCamstudySelect,
    MyChat
  },
  data() {
    return {
      message: '',
      myChatIdx: 0,
      lastChat: {
        vueObj: null,
        props: null,
      },
      chatHistory: [],
      inputValue: '',
      whisperType: 'all',
    }
  },
  created() {
    this.$roomApi.addEventListeners((this._Events = _Events()), this)
  },
  mounted () {
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  computed: {
    ...mapGetters('room', [
      'isLeaved',
    ]),
    ...mapGetters('user', [
        'me',
        'getRoomUser',
        'hasSpeakerRole'
    ]),
    ...mapGetters('camstudy', [
        'getCamStudyUser',
        'enteredCamStudyUserList'
    ]),
    ...mapGetters('chat', [
       'systemMessage',
       'whisperTarget'
    ]),
    inputLengthCheck(){
      return this.inputValue.length !== 0
    },
    getSimpleDateForm() {
      return date => {
        return dayjs(date).format('HH:mm');
      }
    },
    receiveDate(){
      return date => {
        return (
            this.getSimpleDateForm(date)
        )
      }
    },
    roomUserNickname: function() {
      return userId => {
        let ru = this.getRoomUser(userId);
        if(!ru){
          return this.$t('common.leavedUser')
        }
        return ru.nickname.escapeXml();
      }
    },
    displayRoleName() {
      return roleId => {
        switch (roleId) {
          case 'speaker': return this.$t('common.speaker');
          case 'emcee': return this.$t('common.emcee');
          case 'participant': return this.$t('common.participant');
          default: return 'UNKNOWN';
        }
      }
    },
    displayChatTargetList() {
      const userList = this.enteredCamStudyUserList
          .filter(item => item.userId !== this.me.userId)
          .map(item => {
            return {
              name: item.username,
              value: item.userId
            }
          });

      return [
        { name: this.$t('chat.whisper.target.all'), value: 'all' },
        ...userList
      ];
    },
    selectedWhisperTarget: {
      get() {
        return this.whisperTarget || 'all';
      }
    },
  },
  methods: {
    ...mapActions('chat', [
        'sendChatMessage',
        'addUnReadChat'
    ]),
    ...mapMutations('chat',[
      'REMOVE_MY_CHAT',
      'SET_WHISPER_TARGET'
    ]),
    onShowModal () {
      this.toBottomScroll();
    },
    onHideModal () {
    },
    onClose() {
      this.$modal('CamstudyChatModal', {once: true})
    },
    createNewVueInstance({component, props}){
      return new Vue({
        i18n,
        store,
        render: h => h(component, {
          props
        }),
      })
    },
    sendChat(e) {
      if (e.shiftKey) {
        return
      }
      e.preventDefault()

      // const target = e.target
      const text = this.inputValue.trim()

      if (!text.length) {
        return;
      }

      if (text.length > 1000) {
        this.$camsAlert({
          text: this.$t('camstudy.chat.sendMaxLimitLength', {'0': 1000}),
          onlyOk: true
        })
        return
      }

      if (this.selectedWhisperTarget === 'all') {
        this.whisperType = 'all';
      } else {
        this.whisperType = 'whisper';
      }
      let data = {
        text,
        myChatIdx: this.myChatIdx,
        target: this.whisperType,
        toUserId: this.selectedWhisperTarget,
      }
      this.sendChatMessage(data);

      this.inputValue = '';
      this.myChatIdx++;
      this.$refs['input-fake'].focus();
      this.$refs['input-real'].focus();
      this.$nextTick(() => {
        this.toBottomScroll();
      });
    },
    receiveChat(e, type = 'chat') {
      if (!e.data.target) {
        e.data.target = 'all';
      }

      let chatData = {
        type,
        ...e.data,
        userId: e.userId,
        date: e.eventTime,
      }

      this.addChat(chatData);
    },
    addChat(chatData) {
      const {userId} = chatData;

      if (!userId) {
        return;
      }

      this._throttle_addChat_list = this._throttle_addChat_list || [];
      this._throttle_addChat_list.push({
        ...chatData,
        userId,
      });

      const throttle_term = 300;
      if(this._throttle_run){
        return;
      }
      this._addChat_throttle();
      this._throttle_run = setInterval(() => {
        if(this._throttle_addChat_list.length === 0){
          this._throttle_run_loop++;
          if(this._throttle_run_loop > 3){
            clearInterval(this._throttle_run);
            this._throttle_run = null;
          }
          return;
        }
        this._throttle_run_loop = 0;
        this._addChat_throttle();
      }, throttle_term);
    },
    _addChat_throttle() {
      let job;
      while(
          (job=this._throttle_addChat_list.shift()) != null
          ){
        try{
          this.appendMessage({
            ...job
          });
        }catch(e){
          console.error(e);
        }
      }
    },
    appendMessage(messageData) {
      const chatContainer = this.$refs.chatScroll;
      let append = () => {
        if(messageData.type === 'chat' && this.me.userId === messageData.userId){
          this.REMOVE_MY_CHAT(messageData);
        }

        const {date, text, userId, toUserId, type} = messageData;
        const receiveDate = this.receiveDate(date);
        // 새로운 채팅생성 vs 기존 채팅에 추가
        if (!this.lastChat.vueObj
            || this.lastChat.item?.type !== type
            || this.lastChat.item?.userId !== userId
            || this.lastChat.item?.receiveDate !== receiveDate
            || this.lastChat.item?.toUserId !== toUserId) {

          const chatNode = chatContainer.appendChild(document.createElement('div'));
          messageData.receiveDate = receiveDate;
          messageData.nickname = this.roomUserNickname(userId);
          if (toUserId) {
            messageData.receiveUser = this.roomUserNickname(toUserId);
          }

          if (messageData.target === 'staff') {
            messageData.receiveUser = this.$t('chat.whisper.target.staff')
          }

          const profileImageUrl = this.getCamStudyUser(userId)?.profileImageUrl
          if (profileImageUrl) {
            messageData.profileImageUrl = profileImageUrl;
          }

          this.lastChat.item = Vue.observable(messageData);
          let vueData = {
            component: ChatForm,
            props: {
              type: type,
              item: this.lastChat.item,
            },
          };

          this.lastChat.vueObj = this.createNewVueInstance(vueData).$mount(chatNode);
          this.chatHistory.push(vueData)
        } else {
          this.lastChat.item.text += `\r${text}`;
        }

        const limit = 500;
        const gcCnt = chatContainer.childElementCount - limit;
        if(gcCnt > 0){
          for(let i=0; i<gcCnt; i++){
            chatContainer.firstElementChild.remove();
          }
        }
        this.$nextTick(() => {
          this.toBottomScroll()
        });
      }

      if(chatContainer){
        append();
      }else{
        this.$nextTick(() => {
          append();
        });
      }
    },
    toBottomScroll(){
      const scroll = this.$refs.scroll;
      if (scroll) {
        scroll.scrollTop = scroll.scrollHeight
      }
    },
    changeUserRoleIdLog(e) {
      if (!this.systemMessage) {
        return;
      }

      const { roleId, userId } = e.data;
      const roomUser = this.getRoomUser(userId);
      if(!roomUser || !this.me.userId) {
        return;
      }

      const chatNode = document.createElement('div');
      const chatContainer = this.$refs.chatScroll;
      chatContainer.appendChild(chatNode);

      const content = this.$t('chat.roleChanged', { '0' : roomUser.nickname, '1' : this.displayRoleName(roleId) });
      const receiveDate = this.receiveDate(e.eventTime);
      this.lastChat.item = {
        receiveDate,
        content,
      };
      let vueData = {
        component: ChatForm,
        props: {
          section: 'chat',
          type: 'systemMsg',
          item: this.lastChat.item
        },
      };

      this.lastChat.vueObj = this.createNewVueInstance(vueData).$mount(chatNode);
      this.chatHistory.push(vueData);
    },
    roomUserLog(e){
      if(!this.systemMessage) return;
      const roomUser = e.data?.roomUser;
      if(!roomUser || !this.me.userId) {
        return;
      }
      if (roomUser.userId === this.me.userId) {
        return;
      }

      const chatNode = document.createElement('div');
      const chatContainer = this.$refs.chatScroll;
      chatContainer.appendChild(chatNode);

      let msg;
      const type = e.type;
      if(type === 'room_user_enter'){
        msg = this.$t('chat.join');
      } else if(type === 'room_user_leave') {
        const isKicked = e.data.reason === 'kick';
        if(isKicked && this.hasEmceeRole()) {
          msg = this.$t('chat.ban');
        } else {
          msg = this.$t('chat.leave');
        }
      }
      const content = `${roomUser.nickname}님이 ${msg}`;
      const receiveDate = this.receiveDate(e.eventTime);
      this.lastChat.item = {
        receiveDate,
        content,
      };
      let vueData = {
        component: ChatForm,
        props: {
          section: 'chat',
          type: 'systemMsg',
          item: this.lastChat.item
        },
      };

      this.lastChat.vueObj = this.createNewVueInstance(vueData).$mount(chatNode);
      this.chatHistory.push(vueData);
    },
    vacancyLog(e) {
      if(!this.systemMessage) return;
      const userId = e.data.userId;
      const isVacancy = e.data.isVacancy;

      const roomUser = this.getRoomUser(userId);
      if (!roomUser || (!this.hasSpeakerRole() && this.me?.userId !== userId)) {
        return;
      }

      let content = ''
      if(isVacancy) {
        content = this.$t('chat.vacancy.true.toOpener', {'0': roomUser.nickname});
      } else {
        const durationTotalSeconds = e.data.durationSeconds
        const durationMinutes = Math.floor(durationTotalSeconds / 60);
        const durationSeconds = durationTotalSeconds % 60;
        const isEn = this.$i18n.locale === 'en'

        let durationText = '';
        if(durationMinutes > 0) {
          durationText = isEn ? `${durationMinutes}m ${durationSeconds}s` : `${durationMinutes}분 ${durationSeconds}초`;
        } else {
          durationText = isEn ? `${durationSeconds}s` : `${durationSeconds}초`;
        }

        content = this.$t('chat.vacancy.false.toOpener', {'0': roomUser.nickname, '1': durationText});
      }
      const receiveDate = this.receiveDate(e.eventTime);

      const chatNode = document.createElement('div');
      const chatContainer = this.$refs.chatScroll;
      chatContainer.appendChild(chatNode);

      this.lastChat.item = {
        receiveDate,
        content,
      };
      let vueData = {
        component: ChatForm,
        props: {
          section: 'chat',
          type: 'systemMsg',
          item: this.lastChat.item
        },
      };

      this.lastChat.vueObj = this.createNewVueInstance(vueData).$mount(chatNode);
      this.chatHistory.push(vueData);
      if(!this.$isOpenedModal("CamstudyChatModal")){
        this.$toastMessage({type: 'info', content: content})
      }
    },
    onChangeWhisperTarget(data){
      this.SET_WHISPER_TARGET(data);
    },
    getUserImage(userId){
      return this.getCamStudyUser(userId)?.profileImageUrl || require('@/assets/images/user_profile.svg')
    },
    getUserName(userId){
      return this.getRoomUser(userId)?.nickname
    }
  }
}

function _Events() {
  return {
    room_chat_text: function (e) {
      if(!this.$isOpenedModal("CamstudyChatModal")){
        this.addUnReadChat();
        this.$toastMessage({type: 'chat', username: this.getUserName(e.userId), content: e.data.text, userImage: this.getUserImage(e.userId), click: () => {
          this.$modal('CamstudyChatModal')
        }})
      }
      this.receiveChat(e, 'chat');
    },
    room_user_enter: function (e) {
      this.roomUserLog(e)
    },
    room_user_leave: function (e) {
      this.roomUserLog(e)
    },
    room_changeUserRoleId: function (e) {
      this.changeUserRoleIdLog(e);
    },
    room_cstudy_userVacancy: function(e) {
      this.vacancyLog(e);
    },
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile] {
  .modal-cover {
    background-color: rgba(0, 0, 0, 0.5);
    @media(orientation: portrait) {
      left: 0;
      right: 0;
      bottom: 64px;
    }
    @media(orientation: landscape) {
      left: env(safe-area-inset-left);
      right: env(safe-area-inset-right);
      bottom: 98px;
      z-index: 99;
    }
    .chat-container {
      @media(orientation: portrait) {
        bottom: 0;
        left: 0;
        width: 100%;
        .chat-body-container{
          height: 331px;
        }
      }
      @media(orientation: landscape) {
        bottom: 0;
        left: 0;
        top: 0;
        right: 0;
        .chat-body-container{
          height: calc(100% - 101px);
        }
      }
    }
  }
}
html:not([grm-device-mobile]) {
  .modal-cover {
    left: 0;
    right: 0;
    bottom: 80px;
    top: 0;
    .chat-container {
      bottom: -80px;
      top: 0;
      right: 0;
      width: 360px;

      .chat-body-container {
        height: calc(100% - 101px);
      }
      border-left: 0.5px solid rgba(255, 255, 255, 0.20);
      background: #1A1A1A;
    }
  }
}
.modal-cover{
  position: fixed;
  top: 0;
  z-index: 99;
}
.chat-container {
  position: absolute;
  background: #1F1F1F;
  color: white;
  z-index: 100;
  line-height: 1.5;

  .chat-header-container{
    display: flex;
    padding: 6px 16px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }
  .chat-body-container{
    position: relative;
    overflow: scroll;
    padding: 12px 10px;
    &::-webkit-scrollbar {
      display: none;
    }

    .warning-info{
      padding: 10px;
      border-radius: 6px;
      background: #141414;
      .warning-title{
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        color: #FF5353;
        padding-left: 22px;
        background: url('~@/assets/images/camstudy/warning_declaration.svg') no-repeat center left;
      }
      .warning-message{
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        color: #FF5353;
        margin-top: 6px;
      }
    }

    .chat-item {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 12px 0;
      font-size: 14px;
      .user-name{
        padding-left: 48px;
        color: #999;
        font-size: 9px;
        line-height: 150%;
        margin-bottom: 4px;
      }
      .user-image{
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
      .chat-message{
        padding: 8px 12px;
        border-radius: 6px;
        background: #393939;
        text-wrap: wrap;
        color: #FFF;
        font-size: 14px;
        line-height: 140%;
        margin-right: 4px;
        margin-left: 12px;
      }
      .chat-time{
        color: #999;
        font-size: 9px;
        line-height: 150%;
        align-self: flex-end;
      }
      &.me{
        align-items: flex-end;
        .message-container{
          flex-direction: row-reverse;
        }
        .chat-message{
          background: #192F49;
          margin-right: 12px;
          margin-left: 4px;
        }
        .user-name{
          padding-left: 0;
          padding-right: 48px;
        }
      }
    }
  }
  .chat-input-container{
    display: flex;
    width: 100%;
    padding: 12px 10px;
    background: #1F1F1F;
    .chat-input-select-container{
      border-radius: 20px 0 0 20px;
      overflow: hidden;
    }

    .select-target{
      display: flex;
      width: 80px;
      padding: 6px 8px 6px 12px;
      justify-content: space-between;
      align-items: center;
      background: #313131;
      border-radius: 20px 0 0 20px;
      color: #FFF;
      font-size: 14px;
      line-height: 150%;
    }
    .chat-input{
      width: 100%;
      display: flex;
      padding: 6px 12px;
      align-items: center;
      background: #313131;
      border-radius: 0 20px 20px 0;
      .send-chat{
        width: 18px;
        height: 18px;
        background: url('~@/assets/images/camstudy/ico_chat_send_impossible.svg') no-repeat center left;
        &.possible{
          background: url('~@/assets/images/camstudy/ico_chat_send_possible.svg') no-repeat center left;
        }
      }

      input{
        color: white;
        font-size: 14px;
        line-height: 150%;
        width: 100%;
        background: none;
        border: none;
        outline: transparent;

        &::placeholder{
          color: #999;
        }
      }
    }
  }
  .close-modal{
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_close_white.svg") center no-repeat;
    background-size: auto 24px;
  }
  .chat-icon{
    width: 32px;
    height: 32px;
  }
  .fake-input{
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
}
</style>